import {PlayerShowBase} from "./show-base.model";
import {PlayerMix} from "./player-mix.model";
import { PlayerHostBase } from './host-base.model';
import { Expose, Type } from 'class-transformer';
import { PlayerProgramBase } from './program-base.model';


export class PlayerShow extends PlayerShowBase {
  @Expose({name:'_host'})
  @Type(() => PlayerHostBase)
  _host: PlayerHostBase | undefined = undefined;
  @Expose({name:'_program'})
  @Type(() => PlayerProgramBase)
  _program: PlayerProgramBase | undefined = undefined;
  @Expose({name:'_mixes'})
  @Type(() => PlayerMix)
  _mixes: PlayerMix [] = [];
  @Expose({name:'_primary_mix'})
  @Type(() => PlayerMix)
  _primaryMix: PlayerMix | undefined = undefined;
}
